import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInServicePendingChecklist } from "models";

export const useDeleteServicePendingChecklistMutation = () =>
  useTypedMutation<CheckInServicePendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/service_pending_checklists/delete", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ checklist_id, checkin_service_id }) => {
      const servicePendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.servicePendingChecklists);
      if (!servicePendingChecklists?.length) return;

      const servicePendingChecklistIdx = servicePendingChecklists.findIndex(p => p.checklist_id === checklist_id && p.checkin_service_id === checkin_service_id);
      if (servicePendingChecklistIdx === -1) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.servicePendingChecklists, servicePendingChecklists.toSpliced(servicePendingChecklistIdx, 1));
    }
  });
